import { useLocale } from 'locale';
import React from 'react';
import * as Styled from './styled';
import CheckIcon from 'assets/svg/ok-check.svg';
import MailIcon from 'assets/svg/send.svg';
import { PoiId } from 'utils/entities';
import PhoneIcon from 'assets/svg/phone-new.svg';
import { createPhoneURI } from 'hooks/useDisplayPhone';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';
import { PrivateContactProps } from 'components/contact/types';
import UserPlaceholder from 'assets/svg/profile-new.svg';
import { ContactAgentModalSource, ContactModalOpenMeta } from 'store/state/app';
import { Button } from 'ds/components/button';
import { useABTests } from 'hooks/useABTests';
import { ListingPageV5 } from 'config/abTests';
import _ from 'lodash';

interface POIPrivateInnerProps extends PrivateContactProps {
  id: PoiId;
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => void;
  onCallClickEvent?: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
}

export const POIPrivateInner: React.FC<POIPrivateInnerProps> = (props) => {
  const {
    onSetContactModalPoiId,
    onCallClickEvent,
    contactValues,
    isContacted,
    name,
    phone,
    poiType,
    id,
    whatsappNumber,
  } = props;

  const { t } = useLocale();
  const { listingPageV5 } = useABTests();
  const isModeB = listingPageV5 === ListingPageV5.modeB;
  const validPhoneNumber = Boolean(whatsappNumber);

  const handlePhoneSubmit = (e: React.MouseEvent<HTMLElement>) => {
    onCallClickEvent(false, { ...contactValues, id, type: poiType }, ContactAgentModalSource.ContactSection);
  };

  const handleModalOpen = () => {
    onSetContactModalPoiId(id, { source: ContactAgentModalSource.ContactSection });
  };

  return (
    <Styled.Root data-auto="private-poi-inner">
      <Styled.FormTitle weight="bold">{t('contactForm.contact.form.withMortgage.mobile.title', { isContacted: false })}</Styled.FormTitle>
      <Styled.InfoBox>
        <UserPlaceholder width={56} height={56} />
        <Styled.UserName weight="bold">{name}</Styled.UserName>
      </Styled.InfoBox>
      <Styled.FormBody>
        <Styled.PhoneButton
          data-auto="phone-private-inner-number-button"
          size="extraLarge"
          weight="medium"
          onClick={handlePhoneSubmit}
          href={createPhoneURI(phone)}
        >
          <PhoneIcon />
          {t(isModeB ? 'contactAgentPhone.button.modeB' : 'contactAgentModal.button.private.inner')}
        </Styled.PhoneButton>
        {validPhoneNumber ? null : (
          <>
            {isContacted ? (
              <Button isInitialIconColor disabled data-auto="phone-private-inner-number-button-modal-disabled" size="extraLarge" mode="ghost">
                <CheckIcon width={24} height={24} />
                {t('contactAgentModal.button.disabled.modeB.static')}
              </Button>
            ) : (
              <Button isInitialIconColor onClick={handleModalOpen} data-auto="phone-private-inner-number-button-modal" size="extraLarge" mode="ghost">
                <MailIcon width={24} height={24} />
                {t('developerPage.contactButton', { submitted: false, isMobile: false })}
              </Button>
            )}
          </>
        )}
      </Styled.FormBody>
    </Styled.Root>
  );
};
